import {create} from 'zustand'

export enum Panel {
  ADD_TO_HOME_SCREEN = 'A2HS',
  CLAIM = 'claim',
  CONTACT = 'contact',
  CAMERA = 'camera',
  NONE = '',
}
type PanelStoreState = {
  panel: Panel
  scrollPos: number
  setShowPanel: (panel: Panel) => void
  setScrollPos: (pos: number) => void
  closePanel: () => void
}

export const usePanelStore = create<PanelStoreState>((set) => ({
  panel: Panel.NONE,
  scrollPos: 0,
  setShowPanel: (panel: Panel) => set(() => ({panel})),
  setScrollPos: (pos: number) => set(() => ({scrollPos: pos})),
  closePanel: () => set(() => ({panel: Panel.NONE})),
}))
